import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import FloatingButtons from './FloatingButtons';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col font-sans text-gray-800 bg-gray-50">
      <Header />
      <main className="flex-grow pb-[60px] md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
